import { Image } from "@mui/icons-material";
import React, { memo } from "react";

import { getBackendUrl } from "../../../config";
import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();
  const link = getBackendUrl();

  return (
    <NodeCard color="#0891b2" icon={<Image />} title="Imagem" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <img src={`${link}/public/${data.url}`} alt="" className={classes.media} />
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
